import $ from "jquery";

export default class sparLookupComponent extends HTMLDivElement {
    
    get lookupCompleted() {
        return this.dataset.sparLookupCompleted;
    }

    set lookupCompleted(value) {
        this.dataset.sparLookupCompleted = value;
        if (value) {
            this.disableLookup();
        } else {
            this.enableLookup();
        }
    }

    get socialSecurityNumberField() {
        return this.querySelector("[data-spar-lookup='socialSecurityNumber']");
    }

    get socialSecurityNumber() {
        return this.socialSecurityNumberField.value;
    }

    set socialSecurityNumber(value) {
        this.socialSecurityNumberField.value = value;
    }

    get lookupButton() {
        return this.querySelector("[data-spar-lookup='lookup']");
    }

    get lookupUrl() {
        return this.dataset.sparLookupUrl;
    }

    get resetButton() {
        return this.querySelector("[data-spar-lookup='reset']");
    }

    get unsuccessfulMessage() {
        return this.querySelector("[data-spar-lookup='unsuccessful'");
    }

    get disabled() {
        return this.socialSecurityNumberField.hasAttribute('readonly') === true;
    }

    get lookupPerformedField() {
        return this.querySelector("[data-spar-lookup='performed'");
    }

    constructor() {
        super();
    }

    connectedCallback() {

        this.lookupButton.addEventListener('click', this.lookup.bind(this));

        this.resetButton.addEventListener('click',
            e => {
                this.lookupCompleted = false;
                this.lookupPerformedField.value = null;
            });

        this.socialSecurityNumberField.addEventListener("keypress", e => {
            if (e.key === "Enter") {
                e.preventDefault();
                this.lookup();
            }
        });

        if (this.disabled) {
            this.disableLookup();
        } else {
            this.enableLookup();
        }

        if (this.socialSecurityNumberField.value && $(this.socialSecurityNumberField).valid()) {
            this.lookup();
        }

    }

    disconnectedCallback() {
        this.lookupButton.removeEventListener('click');
        this.resetButton.removeEventListener('click');
    }

    attributeChangedCallback(name, oldValue, newValue) {
        console.log("name: " + name + ", oldValue: " + oldValue + ", newValue: " + newValue);
    }

    lookup() {
        if ($(this).closest("form").validate().element("#" + this.socialSecurityNumberField.id)) {
            this.performLookup(this.socialSecurityNumber);
        }
    }

    enableLookup() {
        this.socialSecurityNumberField.removeAttribute('readonly');
        if (!this.socialSecurityNumberField.classList.contains("no-focus")) {
            this.socialSecurityNumberField.focus({preventScroll: true});
        }
        this.lookupButton.removeAttribute('disabled');
        this.lookupButton.classList.remove("hidden");
        this.resetButton.setAttribute("disabled", "");
        this.resetButton.classList.add("hidden");
        this.unsuccessfulMessage.classList.add("hidden");
        this.onReset();
    }

    disableLookup() {
        this.socialSecurityNumberField.setAttribute('readonly', '');
        this.resetButton.removeAttribute('disabled');
        this.resetButton.classList.remove("hidden");
        this.lookupButton.setAttribute("disabled", "");
        this.lookupButton.classList.add("hidden");
    }

    onSparLookupCompleted(status, data) {
        const event = new CustomEvent('sparLookupCompleted', {detail: data});
        this.dispatchEvent(event);
    }

    onReset() {
        const event = new CustomEvent('sparLookupReset');
        this.dispatchEvent(event);

    }

    performLookup(number) {

        let httpRequest = new XMLHttpRequest();

        httpRequest.open('POST', this.lookupUrl);
        httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        httpRequest.send('socialSecurityNumber=' + encodeURIComponent(number));
        httpRequest.onload = e => {
            if (httpRequest.status === 200 && httpRequest.readyState === 4) {

                let retVal = JSON.parse(e.srcElement.responseText);

                this.lookupPerformedField.value = "True";

                if (retVal.Completed === true) {
                    this.lookupCompleted = true;
                    this.onSparLookupCompleted(retVal.Successful, retVal);
                }
                if (retVal.Successful === false) {
                    this.unsuccessfulMessage.classList.remove("hidden");
                }

            }
        };
    }

}

customElements.define('spar-lookup', sparLookupComponent, { extends: "div" });